import { Box, Grid, Typography } from '@mui/material';
import TextField from '@mui/material/TextField';
import { useDispatch } from 'react-redux';
import { useState, useEffect, ChangeEvent } from 'react';

const useStyles = () => ({
  gridItem: { margin: 8 },
  formContainer: { 
    padding: 16
  }
});

interface FormData {
  designacaoProduto: string;
  nomeGenerico: string;
  dosagem: string;
  apresentacao: string;
  numeroAutorizacao: string;
  nomeFabricante: string;
  localFabrico: string;
  numeroAmostras: string;
}

export default function InformacoesProduto() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [formData, setFormData] = useState<FormData>({
    designacaoProduto: '',
    nomeGenerico: '',
    dosagem: '',
    apresentacao: '',
    numeroAutorizacao: '',
    nomeFabricante: '',
    localFabrico: '',
    numeroAmostras: ''
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  useEffect(() => {
    dispatch({
      type: 'dadosProduto',
      payload: { dadosProduto: formData }
    });
  }, [formData, dispatch]);

  return (
    <Box style={classes.formContainer}>
      <Typography variant="h5" style={{ marginBottom: 24 }}>
        INFORMAÇÕES DO PRODUTO
      </Typography>

      <Grid container spacing={2}>
        {/* Primeira linha: Designação do produto (ocupa toda largura) */}
        <Grid item xs={12}>
          <TextField
            required
            type="text"
            label="Designação do produto"
            fullWidth
            size="small"
            name="designacaoProduto"
            variant="outlined"
            onChange={handleChange}
            value={formData.designacaoProduto}
          />
        </Grid>

        {/* Segunda linha: Nome genérico e Dosagem */}
        <Grid item xs={12} md={8}>
          <TextField
            required
            type="text"
            label="Nome genérico"
            fullWidth
            size="small"
            name="nomeGenerico"
            variant="outlined"
            onChange={handleChange}
            value={formData.nomeGenerico}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            required
            type="text"
            label="Dosagem"
            fullWidth
            size="small"
            name="dosagem"
            variant="outlined"
            onChange={handleChange}
            value={formData.dosagem}
          />
        </Grid>

        {/* Terceira linha: Apresentação (ocupa toda largura) */}
        <Grid item xs={12}>
          <TextField
            required
            type="text"
            label="Apresentação (comprimido, frascos, etc...)"
            fullWidth
            size="small"
            name="apresentacao"
            variant="outlined"
            onChange={handleChange}
            value={formData.apresentacao}
          />
        </Grid>

        {/* Quarta linha: Nº de autorização (ocupa toda largura) */}
        <Grid item xs={12}>
          <TextField
            required
            type="text"
            label="Nº de autorização de introdução no mercado ou registo"
            fullWidth
            size="small"
            name="numeroAutorizacao"
            variant="outlined"
            onChange={handleChange}
            value={formData.numeroAutorizacao}
          />
        </Grid>

        {/* Quinta linha: Nome do fabricante e Local de fabrico */}
        <Grid item xs={12} md={6}>
          <TextField
            required
            type="text"
            label="Nome do fabricante"
            fullWidth
            size="small"
            name="nomeFabricante"
            variant="outlined"
            onChange={handleChange}
            value={formData.nomeFabricante}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            required
            type="text"
            label="Local de fabrico"
            fullWidth
            size="small"
            name="localFabrico"
            variant="outlined"
            onChange={handleChange}
            value={formData.localFabrico}
          />
        </Grid>

        {/* Sexta linha: Nº de amostra (ocupa metade da largura) */}
        <Grid item xs={12} md={6}>
          <TextField
            required
            type="number"
            label="Nº de amostra (em unidade)"
            fullWidth
            size="small"
            name="numeroAmostras"
            variant="outlined"
            onChange={handleChange}
            value={formData.numeroAmostras}
          />
        </Grid>
      </Grid>
    </Box>
  );
}